export enum StatUsagePref {
	ORDER = 'statistics.usage.containers.order',
	ASSETS_COLLAPSED = 'statistics.usage.pod.assets.collapsed',
	BANDWIDTH_COLLAPSED = 'statistics.usage.pod.bandwidth.collapsed',
	DETAILS_COLLAPSED = 'statistics.usage.pod.details.collapsed',
	JOBS_COLLAPSED = 'statistics.usage.pod.jobs.collapsed',
	STORAGE_COLLAPSED = 'statistics.usage.pod.storage.collapsed',
	USERS_COLLAPSED = 'statistics.usage.pod.users.collapsed',
}

export enum StatQueryLayout {
	GRAPH = 'graph',
	LIST = 'list',
}

export enum StatDateType {
	TODAY = 1,
	THIS_WEEK = 2,
	THIS_MONTH = 3,
	THIS_YEAR = 4,
	SELECTED_DATE = 5,
	BEFORE_DATE = 6,
	AFTER_DATE = 7,
	BETWEEN_DATES = 8,
}

export enum StatType {
	APPROVED_DOWNLOAD_REQUEST_ASSETS = 37,
	APPROVED_DOWNLOAD_REQUESTS = 35,
	// Not implemented yet
	// ASSET_ARCHIVED = 57,
	// ASSET_UNARCHIVED = 58,
	ASSET_DOWNLOADS = 46,
	ASSETS_CHECKED_IN = 24,
	ASSETS_CHECKED_OUT = 25,
	ASSETS_DELETED = 10,
	ASSETS_IMPORTED = 20,
	ASSETS_LINKED = 26,
	ASSETS_PLACED = 27,
	// DAM-11703
	// ASSETS_PROCESSED = 13,
	ASSETS_SEARCHED = 14,
	ASSETS_VIEWED = 12,
	CATEGORIES_DELETED = 17,
	CATEGORIES_VIEWED = 18,
	DENIED_DOWNLOAD_REQUEST_ASSETS = 38,
	DENIED_DOWNLOAD_REQUESTS = 36,
	FILE_DOWNLOADS = 52,
	SESSION_EXPIRATION = 3,
	SHARED_ASSETS = 54,
	SHARED_FILES = 53,
	USER_LOGINS = 1,
}

export enum StatQueryObjectType {
	ASSET_ID = 1,
	CATEGORY_ID = 2,
	USER_ID = 3,
	STATUS = 4,
	/** genric object id */
	OBJECT_ID = 5,
}

export enum StatQueryStatusType {
	PENDING_APPROVAL = 2,
	APPROVED = 3,
	DENIED = 4,
}

export const STAT_TYPE_COLOR: Record<StatType, string> = <const>{
	[StatType.APPROVED_DOWNLOAD_REQUEST_ASSETS]: '#c6b9e4',
	[StatType.APPROVED_DOWNLOAD_REQUESTS]: '#c6b9e4',
	// [StatType.ASSET_ARCHIVED]: '#f44336',
	[StatType.ASSET_DOWNLOADS]: '#c6b9e4',
	// [StatType.ASSET_UNARCHIVED]: '#ff9800',
	[StatType.ASSETS_CHECKED_IN]: '#b2eced',
	[StatType.ASSETS_CHECKED_OUT]: '#b6e7e1',
	[StatType.ASSETS_DELETED]: '#d5ecf5',
	[StatType.ASSETS_IMPORTED]: '#cfe8ff',
	[StatType.ASSETS_LINKED]: '#c7fed7',
	[StatType.ASSETS_PLACED]: '#e0f2c4',
	// [StatType.ASSETS_PROCESSED]: '#fef7c7',
	[StatType.ASSETS_SEARCHED]: '#ebd5fc',
	[StatType.ASSETS_VIEWED]: '#ffd9ff',
	[StatType.CATEGORIES_DELETED]: '#c7c7fe',
	[StatType.CATEGORIES_VIEWED]: '#fee8b7',
	[StatType.DENIED_DOWNLOAD_REQUEST_ASSETS]: '#c6b9e4',
	[StatType.DENIED_DOWNLOAD_REQUESTS]: '#c6b9e4',
	[StatType.FILE_DOWNLOADS]: '#c6b9e4',
	[StatType.SESSION_EXPIRATION]: '#feb7b7',
	[StatType.SHARED_ASSETS]: '#c6b9e4',
	[StatType.SHARED_FILES]: '#c6b9e4',
	[StatType.USER_LOGINS]: '#ffd2c3',
};

export enum StatUsageFormat {
	BYTES = 'Bytes',
	INTEGER = 'Integer',
}

export enum StatUsageType {
	ASSETS = 'assets',
	BANDWIDTH = 'bandwidth',
	JOBS = 'jobs',
	STORAGE = 'storage',
	USERS = 'users',
}

export enum WeeklyStatType {
	// ASSET_ARCHIVED = 57,
	ASSET_DOWNLOADS = 46,
	// ASSET_UNARCHIVED = 58,
	ASSETS_CHECKED_IN = 24,
	ASSETS_CHECKED_OUT = 25,
	ASSETS_DELETED = 10,
	ASSETS_IMPORTED = 20,
	ASSETS_LINKED = 26,
	ASSETS_PLACED = 27,
	// DAM-11703
	// ASSETS_PROCESSED = 13,
	ASSETS_SEARCHED = 14,
	ASSETS_VIEWED = 12,
	CATEGORIES_VIEWED = 18,
	USER_LOGINS = 1,
}

export const WEEKLY_STAT_TYPES = <const>[
	WeeklyStatType.USER_LOGINS,
	WeeklyStatType.ASSETS_DELETED,
	WeeklyStatType.ASSETS_VIEWED,
	WeeklyStatType.ASSETS_SEARCHED,
	WeeklyStatType.CATEGORIES_VIEWED,
	WeeklyStatType.ASSETS_IMPORTED,
	WeeklyStatType.ASSETS_CHECKED_IN,
	WeeklyStatType.ASSETS_CHECKED_OUT,
	WeeklyStatType.ASSETS_LINKED,
	WeeklyStatType.ASSETS_PLACED,
	WeeklyStatType.ASSET_DOWNLOADS,
];

export enum StatExogenPropertyDetailName {
	LAST_RESTART = 'lastRestart',
	REAL_PATH = 'realPath',
	APP_VERSION = 'appVersion',
	CLEAN_VERSION = 'cleanVersion',
	CLEAN_BRANCH = 'cleanBranch',
	SERVER_VERSION = 'serverVersion',
	SERVER_BRANCH = 'serverBranch',
	THEME_VERSION = 'themeVersion',
	THEME_BRANCH = 'themeBranch',
	EXOGEN_VERSION = 'exogenVersion',
	PARENT_OPERATING_SYSTEM = 'parentOperatingSystem',
	APP_SERVER = 'appServer',
	JAVA = 'java',
	JAVA_MEMORY_HEAP = 'jvmMemoryHeap',
	JAVA_MEMORY_FREE = 'jvmMemoryFree',
	DATABASE_NAME = 'databaseName',
	ACTIVE_DATABASE_CONNECTIONS = 'activeDatabaseConnections',
	IDLE_DATABASE_CONNECTIONS = 'idleDatabaseConnections',
	MAXIMUM_DATABASE_CONNECTIONS = 'maximumDatabaseConnections',
	JOB_QUEUE_ENTRIES = 'jobQueueEntries',
	JOB_QUEUE_LAG = 'jobQueueLag',
	LOG_FILE_THRESHOLD = 'logFileThreshold',
	ASSETS = 'assets',
	USERS = 'users',
	EXOGEN_LICENSE_SERIAL = 'exogenLicenseSerial',
	EXOGEN_LICENSE_ISSUE_DATE = 'exogenLicenseIssueDate',
	EXOGEN_LICENSE_EXPIRE_DATE = 'exogenLicenseExpireDate',
	EXOGEN_LICENSE_MODULES = 'exogenLicenseModules',
	EXOGEN_LICENSE_ORG = 'exogenLicenseOrg',
	EXOGEN_LICENSE_EMAIL = 'exogenLicenseEmail',
	SEARCH_QUEUED_UPDATES = 'searchQueuedUpdates',
	SEARCH_QUEUED_DELETES = 'searchQueuedDeletes',
}

export const STAT_EXOGEN_PROPERTY_CHART = <const>[
	StatExogenPropertyDetailName.JAVA_MEMORY_HEAP,
	StatExogenPropertyDetailName.JAVA_MEMORY_FREE,
	StatExogenPropertyDetailName.ACTIVE_DATABASE_CONNECTIONS,
	StatExogenPropertyDetailName.IDLE_DATABASE_CONNECTIONS,
	StatExogenPropertyDetailName.JOB_QUEUE_ENTRIES,
	StatExogenPropertyDetailName.JOB_QUEUE_LAG,
	StatExogenPropertyDetailName.SEARCH_QUEUED_DELETES,
];

export const STAT_QUERY_LIST_PAGE_SIZE = 25;
